import * as React from 'react';

import { Button } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';
import { ContainerStatus, enumContainerStatus } from '../../types/container';

import { TRANSITION_MAP } from './ContainerTransitionDialog';

import { useTranslations as useSharedTranslations } from '~/shared/i18n/useTranslations';

interface ContainerDetailHeaderActionsProps {
  containerStatus?: ContainerStatus;
  onVoid?: () => void;
  onUpdateStatus?: () => void;
}

//
// ⚛️ ⚛️ ⚛️ CONTAINER DETAIL HEADER ACTIONS ⚛️ ⚛️ ⚛️
//
export const ContainerDetailHeaderActions: React.FC<
  ContainerDetailHeaderActionsProps
> = ({ containerStatus, onVoid, onUpdateStatus }) => {
  // Translations
  const t = useTranslations();
  const sharedT = useSharedTranslations();

  const canVoid =
    containerStatus !== enumContainerStatus.Shipped &&
    containerStatus !== enumContainerStatus.Voided;

  const transition = containerStatus
    ? TRANSITION_MAP[containerStatus]
    : undefined;

  const statusLabels: Record<ContainerStatus, string> = {
    [enumContainerStatus.AtPort]: sharedT.containerStatus.atPort,
    [enumContainerStatus.InTransitToFacility]:
      sharedT.containerStatus.inTransitToFacility,
    [enumContainerStatus.AtFacilityEmpty]:
      sharedT.containerStatus.atFacilityEmpty,
    [enumContainerStatus.AtFacilityLoaded]:
      sharedT.containerStatus.atFacilityLoaded,
    [enumContainerStatus.InTransitToPort]:
      sharedT.containerStatus.inTransitToPort,
    [enumContainerStatus.AtPortReadyToShip]:
      sharedT.containerStatus.atPortReadyToShip,
    [enumContainerStatus.Shipped]: sharedT.containerStatus.shipped,
    [enumContainerStatus.Voided]: sharedT.containerStatus.voided,
  };

  const transitionLabel = transition
    ? t.containersView.detail.actions.transitionTo(
        statusLabels[transition.nextStatus],
      )
    : undefined;

  if (!canVoid && !transition) {
    return null;
  }

  return (
    <div className="@ContainerDetailHeaderActions flex items-center gap-2">
      {canVoid && (
        <Button variant="outline" color="failure" onPress={onVoid}>
          {t.containersView.actions.void}
        </Button>
      )}
      {transition && (
        <Button onPress={onUpdateStatus}>{transitionLabel}</Button>
      )}
    </div>
  );
};
